import { Box } from "@mui/material";
import { FC } from "react";
import { ICPAnalysisMethodSelector } from "./ICPAnalysisMethodSelector";

interface ICPDefinitionTabProps {
  /** Callback to switch to analysis tab */
  onViewAnalysis: () => void;
}

/**
 * ICP Definition tab component
 */
export const ICPDefinitionTab: FC<ICPDefinitionTabProps> = ({
  onViewAnalysis,
}) => {
  return (
    <Box sx={{ flex: 1, overflow: "auto" }}>
      <ICPAnalysisMethodSelector onViewAnalysis={onViewAnalysis} />
    </Box>
  );
};
